import apiV2 from '../api/v2';
import { toApiError } from './apiErrors';

export interface EditPatientBody {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    // Identity - empty string clears the field.
    gender?: string;
    dateOfBirth?: string;
    // Treatment - empty string clears the field.
    version?: string;
    caseType?: string;
    subCaseType?: string;
    manufacturer?: string;
    alignerOption?: string;
    refinementsCount?: string;
    treatmentGoals?: string;
    additionalInfo?: string;
    iteroScanId?: string;
}

export interface SyncStatus {
    ok: boolean;
    skipped?: boolean;
    error?: string;
}

export interface EditPatientResult {
    patient: {
        id: string;
        firstName: string;
        lastName: string;
        email: string | null;
        phone: string | null;
    };
    // No mondaySync: the Monday mirror runs server-side after the response
    // (route-level syncPatientAfterWrite hook), so its outcome is unknowable
    // at response time.
    dmSync: SyncStatus;
}

export async function editPatient(
    patientId: string,
    body: EditPatientBody
): Promise<EditPatientResult> {
    try {
        const response = await apiV2.patch<{ success: boolean; data: EditPatientResult }>(
            `/patients/${patientId}`,
            body
        );
        return response.data.data;
    } catch (err) {
        throw toApiError(err);
    }
}

export interface MovePatientPracticeResult {
    patientId: string;
    practiceIdBefore: string | null;
    practiceIdAfter: string;
}

export async function movePatientPractice(
    patientId: string,
    practiceId: string
): Promise<MovePatientPracticeResult> {
    try {
        const response = await apiV2.post<{ success: boolean; data: MovePatientPracticeResult }>(
            `/patients/${patientId}/move-practice`,
            { practiceId }
        );
        return response.data.data;
    } catch (err) {
        throw toApiError(err);
    }
}
